'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef } from 'react';
import { ALGOLIA_SEARCH_QUERY_DEBOUNCE_MS } from 'commons/constants';
const registeredResets = new Set();

// Full reset (timer + typed query). Used when the modal closes / search clears.
export const cancelDebouncedAlgoliaQuery = () => {
  registeredResets.forEach(resetFn => resetFn());
};
const useDebouncedAlgoliaQueryHook = t0 => {
  const $ = _c(9);
  const delayMs = t0 === undefined ? ALGOLIA_SEARCH_QUERY_DEBOUNCE_MS : t0;
  const timerRef = useRef(null);
  const typedQueryRef = useRef("");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (timerRef.current != null) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const cancel = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      cancel();
      typedQueryRef.current = "";
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const reset = t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      registeredResets.add(reset);
      return () => {
        reset();
        registeredResets.delete(reset);
      };
    };
    t4 = [reset];
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  let t5;
  if ($[4] !== delayMs) {
    t5 = (query, search) => {
      typedQueryRef.current = query;
      if (timerRef.current != null) {
        clearTimeout(timerRef.current);
      }
      if (!query) {
        timerRef.current = null;
        search(query);
        return;
      }
      timerRef.current = setTimeout(() => {
        timerRef.current = null;
        search(query);
      }, delayMs);
    };
    $[4] = delayMs;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const queryHook = t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => typedQueryRef.current;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const getTypedQuery = t6;
  let t7;
  if ($[7] !== queryHook) {
    t7 = {
      queryHook,
      cancel,
      reset,
      getTypedQuery
    };
    $[7] = queryHook;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};
export default useDebouncedAlgoliaQueryHook;